import { gql, useQuery } from "@apollo/client";

export type Theme = {
  id: string;
  primaryFont: string;
  primaryBg: string;
  accent1: string;
  accent2: string;
  accent3: string;
  accent4: string;
  accent5: string;
  accent6: string;
  headerFont: string;
  bodyFont: string;
  headerFontSize: number;
  bodyFontSize: number;
};

export type ThemeResponse = {
  theme: Theme;
};

const ThemeQuery = gql`
  query theme {
    theme {
      id
      primaryFont
      primaryBg
      accent1
      accent2
      accent3
      accent4
      accent5
      accent6
      headerFont
      bodyFont
      headerFontSize
      bodyFontSize
    }
  }
`;

export const useThemeQuery = () =>
  useQuery<ThemeResponse>(ThemeQuery, {
    fetchPolicy: "no-cache",
  });
